import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GuestDashBoardService } from '../../pages/dashboard/guest-dashboard.service';
import { CommonService } from '../../../helpers/common.service';
import { Router } from '@angular/router';

@Component({
	standalone: false,
	selector: 'app-guest-onboarding-modal',
	providers: [GuestDashBoardService],
	templateUrl: './guest-onboarding-modal.component.html',
	styleUrl: './guest-onboarding-modal.component.scss'
})
export class GuestOnboardingModalComponent {
	progressVal: any = 0;
	constructor(private modalController: ModalController,private router: Router,
		private serviceFile: GuestDashBoardService,
		public commonService: CommonService) { this.getOnboardingProgress(); }

	dismiss() {
		this.modalController.dismiss();
	}

	getOnboardingProgress() {
		this.serviceFile.getUserOnboardData(localStorage.getItem("GuestMobileNumber"))
			.subscribe((res: any) => {
				if (res && res['ArrayOfResponse'] && res['ArrayOfResponse'].length > 0) {
					this.progressVal = res['ArrayOfResponse'][0]['UserOnBoardPrecentage'] / 100;
				} else if (res && res['Message'] === "User Doesn't Exists") {
					this.progressVal = 0;
				}
			});
	}

	onResumeOnboarding() {
		this.commonService.setClevertapEvent("Guest_ResumeOnboarding_Clicked", { 'Mobile Number': localStorage.getItem("GuestMobileNumber") });
		this.commonService.triggerAppsflyerLogEvent('Guest_ResumeOnboarding_Clicked', { 'Mobile Number': localStorage.getItem("GuestMobileNumber") });
		this.router.navigate(['/guest/guest-dashboard']);
		this.dismiss();
	}
	goToDashboard() {
        this.router.navigate(['/guest/guest-dashboard']);
		this.modalController.dismiss();
    }
}

